<template>
  <v-container>
    <div class="header-buttons">
      <div>
        <v-btn color="primary" dark block @click="$router.go(-1)">
          Back
        </v-btn>
      </div>
      <div v-if="authPermissions.has('consumer_loans:create')">
        <export-consumer-loan :loading="cxLoading" :consumerId="consumerId"
          :consumerName="cxData.name || null"></export-consumer-loan>
      </div>
      <div v-if="authPermissions.has('consumer_loans:view')">
        <v-btn color="primary" dark block @click="printSummaryOfLoans">
          Summary of Loans
        </v-btn>
      </div>
    </div>
    <v-row>
      <v-col cols="12" lg="3" v-if="authPermissions.has('consumer_loans:create')">
        <v-toolbar color="primary" dark>
          Add Loan Batch
        </v-toolbar>
        <create-consumer-loan :propConsumerId="consumerId" />
      </v-col>
      <v-col cols="12" md="9" lg="9" v-if="authPermissions.has('consumer_loans:view')">
        <v-toolbar color="primary" dark>
          List of Loans
        </v-toolbar>
        <index-consumer-loan :propConsumerId="consumerId" @edit="initEditConsumerLoan" />
      </v-col>
    </v-row>
    <v-dialog dismissable max-width="600px" v-model="editConsumerLoan" eager class="pa-0">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-card-title>Edit</v-card-title>
        </v-toolbar>
        <edit-consumer-loan :propConsumerId="consumerId" :propConsumerLoan="consumerLoan" />
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style lang="scss" scoped>
.header-buttons {
  display: flex;
  margin: 0px;
  margin-bottom: 10px;

  &>* {
    margin-right: 10px;
  }

  &>*:last-child {
    margin-right: 0;
  }
}
</style>
<script>
import consumerRepository from '@/repositories/consumer.repository'
import { apiVars, errorHandler } from '@/extra-functions/api-helper.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'
import LoanSummary from '@/pdf/loan-summary.pdf'
import { formatAccounting } from '@/lib/utils'
import { mapState } from 'vuex'

const cxGetDelay = searchDelay(100)

export default {
  name: 'consumer-loan',
  created() {
    this.getConsumers()
  },
  components: {
    indexConsumerLoan: () => import('@/views/dashboard/components/consumer-loans/Index'),
    createConsumerLoan: () => import('@/views/dashboard/components/consumer-loans/Create'),
    editConsumerLoan: () => import('@/views/dashboard/components/consumer-loans/Edit'),
    exportConsumerLoan: () => import('./Export'),
  },
  data() {
    return {
      consumerId: this.$route.params.consumer,
      consumerLoan: {},
      editConsumerLoan: false,
      gettingSummaryOfLoans: false,
      ...apiVars('cx', { data: {} }),
    }
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    getConsumers() {
      if (this.cxLoading) return
      cxGetDelay(() => {
        consumerRepository.show(this.consumerId)
          .then(({ data }) => { this.cxData = data })
          .catch(e => { this.cxErrors = errorHandler(e) })
          .then(() => { this.cxLoading = false })
      })
    },
    initEditConsumerLoan(consumerLoan) {
      this.consumerLoan = consumerLoan
      this.editConsumerLoan = true
    },
    async printSummaryOfLoans() {
      try {
        if (this.gettingSummaryOfLoans) return
        this.gettingSummaryOfLoans = true
        const { data } = await consumerRepository.summaryOfLoans(this.consumerId)
        const loanSummary = new LoanSummary()
        const summaryData = {
          name: data?.name,
          paidAmount: formatAccounting(data?.total_paid_amount),
          totalAmount: formatAccounting(data?.total_amount),
          balance: formatAccounting(data?.balance),
          address: data?.address,
        }
        const summaryItems = data.items.map(item => {
          return {
            receiptNo: item?.receipt_no?.trim(),
            noOfItems: item.no_of_items,
            amount: formatAccounting(item.amount),
            paidAmount: formatAccounting(item.paid_amount),
            unpaidAmount: formatAccounting(item.unpaid_amount),
          }
        })

        loanSummary.generate(summaryData, summaryItems)
      } catch (e) {
        alert('oops something went wrong')
      } finally {
        this.gettingSummaryOfLoans = false
      }
    },
  },
}
</script>
